module.exports = __webpack_public_path__ + "img/product1.081bf019.jpg";